import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { formatApiErrorDetail } from "@/lib/api";

export default function LoginPage() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Accesso effettuato");
      nav("/app");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Errore accesso");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex bg-[#F8FAFC]">
      <div className="hidden md:flex md:w-1/2 relative overflow-hidden" style={{background: "linear-gradient(135deg, #1F4E79 0%, #2E6DA4 45%, #00A896 85%, #F7941E 125%)"}}>
        <div className="relative z-10 p-12 flex flex-col justify-between text-white">
          <div>
            <img src="/isteform-logo-white.svg" alt="Centro Studi ISTEFORM" className="h-16 w-auto mb-4"/>
            <div className="text-xs uppercase tracking-[0.3em] opacity-80">Formazione Accreditata<br/>Regione Calabria</div>
          </div>
          <div className="max-w-md">
            <div className="text-xl font-semibold mb-3">Portale Gestionale e Didattico</div>
            <p className="opacity-90">Accedi alla tua area riservata: direzione, docenti e allievi. Corsi, presenze, rate e materiali in un unico posto.</p>
          </div>
          <div className="h-1.5 w-40 rounded-full bg-gradient-to-r from-[#F7941E] via-[#00A896] to-white/60"/>
        </div>
      </div>
      <div className="flex-1 flex items-center justify-center p-6">
        <div className="w-full max-w-md">
          <div className="mb-8">
            <div className="text-[11px] font-bold uppercase tracking-[0.2em] text-[#F7941E] mb-2">Area Riservata</div>
            <h1 className="text-3xl font-extrabold text-slate-900">Accedi al portale</h1>
            <p className="text-slate-600 mt-2">Direzione · Docenti · Allievi</p>
          </div>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label htmlFor="email">Email o Username</Label>
              <Input id="email" data-testid="login-email-input" type="text" value={email} onChange={(e)=>setEmail(e.target.value)} required placeholder="tua.email@isteform.it oppure mario.rossi"/>
            </div>
            <div>
              <Label htmlFor="password">Password</Label>
              <Input id="password" data-testid="login-password-input" type="password" value={password} onChange={(e)=>setPassword(e.target.value)} required/>
            </div>
            <Button type="submit" disabled={loading} className="w-full bg-[#F7941E] hover:bg-[#E08316] text-white font-semibold uppercase tracking-wider" data-testid="login-submit-btn">
              {loading ? "Accesso..." : "Accedi"}
            </Button>
            <div className="flex items-center justify-between text-sm">
              <Link to="/forgot-password" className="text-[#1F4E79] hover:underline" data-testid="login-forgot-link">Password dimenticata?</Link>
              <Link to="/iscrizioni-online" className="text-slate-500 hover:text-[#F7941E]" data-testid="login-iscriviti-link">Iscriviti ai corsi →</Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
